/**
 * General hooks for using resources of various types
 **/


import {useSelector,useDispatch} from 'react-redux'
import {
	getEventDetails,
	getEventTypeKey,
	selectUserEvents,
} from '../state/events'
import useCurrentUser from '../hooks/useCurrentUser'

export const useResource = (type,id)=>{
	const dispatch = useDispatch()
	const resource = useSelector(
		state => {
			switch(type){
				case "task":
				case "nutrition":
				case "workout": 
					const event =Boolean(id)&&state.allEvents[getEventTypeKey(type)].entities[id]
					return event
				break//end task/nutrition/workout
			}//end switch
		}//end selector
	)

	// trigger fetch details if needed this should only ever happen if 
	// the event was opened and then edited which causes getEvents to 
	// be be dispatched. getEvents will update all 
	const isEventType = ['workout','task','nutrition'].includes(type)
	if (
		isEventType
		&&resource
		&&resource.showDetails
		&&!resource.hasDetails
		&&!resource.detailsPending
	) {
		dispatch(getEventDetails({
			event_type:type,
			event_id:id,
		}))
	}

	return resource
}